'use client'
import { FC, Dispatch, SetStateAction } from 'react'
import { testIds } from '@/root/shared-consts'
import { useGetTranslations } from '@/root/shared-hooks'
import cn from 'classnames'
import { OneWayIcon } from '@/root/ui/shared/icons/OneWayIcon'
import { RoundTripIcon } from '@/root/ui/shared/icons/RoundTripIcon'

interface TripTypeToggleProps {
  hideRoundtripButton: boolean
  setHideRoundTripButton: Dispatch<SetStateAction<boolean>>
}

export const TripTypeToggle: FC<TripTypeToggleProps> = ({ hideRoundtripButton, setHideRoundTripButton }) => {
  const { getTranslation } = useGetTranslations()

  const isOneWay = !hideRoundtripButton
  const isRoundTrip = hideRoundtripButton

  return (
    <div className="relative flex rounded-full bg-white">
      {/* Sliding indicator */}
      <div
        className={cn(
          'bg-base-medium-light absolute top-0 bottom-0 rounded-full transition-all duration-300 ease-in-out',
          isOneWay ? 'left-0 w-1/2' : 'left-1/2 w-1/2'
        )}
      />

      {/* One Way button */}
      <button
        onClick={() => isRoundTrip && setHideRoundTripButton(false)}
        data-testid={testIds.sailSelect.oneWay}
        className="relative z-10 flex h-12 items-center justify-between gap-x-2 rounded-full px-6 py-4 transition-colors duration-300"
      >
        <OneWayIcon
          width={40}
          className="mt-2 transition-all duration-300"
          color={isOneWay ? 'white' : 'base-medium-light'}
        />
        <div
          className={cn(
            'text-center text-sm leading-tight transition-colors duration-300',
            isOneWay ? 'text-white' : 'text-gray-500'
          )}
        >
          {getTranslation('oneWay')}
        </div>
      </button>

      {/* Round Trip button */}
      <button
        onClick={() => isOneWay && setHideRoundTripButton(true)}
        data-testid={testIds.sailSelect.addReturnRouteButton}
        className="relative z-10 flex h-12 items-center justify-between gap-x-2 rounded-full px-6 py-4 transition-colors duration-300"
      >
        <RoundTripIcon
          width={40}
          className="transition-all duration-300"
          color={isRoundTrip ? 'white' : 'base-medium-light'}
        />
        <div
          className={cn(
            'text-center text-sm leading-tight transition-colors duration-300',
            isRoundTrip ? 'text-white' : 'text-gray-500'
          )}
        >
          {getTranslation('addReturnRouteLabel')}
        </div>
      </button>
    </div>
  )
}
